import React, {useEffect, useState} from 'react';
import {requestGetJobRequirementInfo} from "@app/services/JobService";
import {callApiSaveJob} from "@pages/job/common/Services";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";

const JobRequirementContent = (props) => {
    const [job, setJob] = useState({input_job_requirement: {}});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {jobInput, mode, onChange} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const fetchJobRequirementInfo = async (jobId) => {
        if (jobId) {
            const res = await requestGetJobRequirementInfo({job_id: jobId})
            const changeJob = {...jobInput}
            changeJob.job_id = jobId
            changeJob.input_job_requirement = res.content
            setJob(changeJob)
        }
    };

    useEffect(async () => {
        if (jobInput && mode !== CandidateDetailLanguageMode.SEARCH) {
            if (!jobInput.input_job_requirement) {
                jobInput.input_job_requirement = {}
            }
            setJob(jobInput)

            if (jobInput.id) {
                await fetchJobRequirementInfo(jobInput.id)
            }
        }
    }, [jobInput]);

    const onChangeRequirementInfo = (fieldName, value) => {
        job.input_job_requirement[fieldName] = value
        setJob({...job})
        if (onChange) {
            onChange(job)
        }
    };

    const onSave= () => {
        callApiSaveJob(job, (res) => {
            const newJob = res.content
            job.id = newJob.id
            setJob({...job})
        })
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Yêu cầu</h3>
                <div className='card-tools'>
                    {mode !== CandidateDetailLanguageMode.SEARCH &&
                    <button type='button' className='btn btn-primary'
                            onClick={() => onSave()}>Save
                    </button>
                    }
                </div>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Yêu cầu với UV (for user nội bộ)</label>
                    <div style={{width: '100%'}}>
                        <textarea className='form-control'
                                  value={job.input_job_requirement.required_extracted ?
                                      job.input_job_requirement.required_extracted : ''}
                                  disabled={!userLoginInfo.is_superuser}
                                  name={'required_extracted'}
                                  onChange={event => onChangeRequirementInfo("required_extracted", event.target.value)}/>
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Yêu cầu đối với UV (to send)</label>
                    <div style={{width: '100%'}}>
                        <textarea className='form-control'
                                  value={job.input_job_requirement.required_candidate_to_send ?
                                      job.input_job_requirement.required_candidate_to_send : ''}
                                  name={'required_candidate_to_send'}
                                  onChange={event => onChangeRequirementInfo("required_candidate_to_send", event.target.value)}/>
                        <AllUserInputField arrInfo={job.input_job_requirement.all_other_user_input} field='required_candidate_to_send' canDelete={false}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobRequirementContent;
